<div class="btn-container" class="hd-action-btn-container" fxLayout="row" fxLayoutAlign="center" fxLayout.xs="column" fxLayout.sm="column">

    <div *ngFor="let btn of btns">

        <!-- <div *ngIf="btn.tipo === 'espacio'" class="space">
        </div> -->

        <div *ngIf="btn.tipo === 'raised'">
            <button mat-raised-button [color]="btn.color" [matTooltip]="btn.tooltip" [disabled]="btn.disabled" (click)="actionBtn(btn.key)">
                {{ btn.texto | titlecase }}
                <mat-icon *ngIf="btn.icono">{{ btn.icono }}</mat-icon>
            </button>
        </div>

        <div *ngIf="btn.tipo === 'stroked'">
            <button mat-stroked-button [color]="btn.color" [matTooltip]="btn.tooltip" [disabled]="btn.disabled" (click)="actionBtn(btn.key)">
                {{ btn.texto | titlecase }}
                <mat-icon *ngIf="btn.icono">{{ btn.icono }}</mat-icon>
            </button>
        </div>
        
        <div *ngIf="btn.tipo === 'flat'">
            <button mat-flat-button [color]="btn.color" [matTooltip]="btn.tooltip" [disabled]="btn.disabled" (click)="actionBtn(btn.key)">
                {{ btn.texto | titlecase }}
                <mat-icon *ngIf="btn.icono">{{ btn.icono }}</mat-icon>
            </button>
        </div>

        <div *ngIf="btn.tipo === 'icon'">
            <button mat-icon-button [color]="btn.color" [matTooltip]="btn.tooltip" [disabled]="btn.disabled" (click)="actionBtn(btn.key)">
                <mat-icon>
                    {{ btn.icono }}
                </mat-icon>
            </button>
        </div>

        <div *ngIf="btn.tipo === 'fab'">
            <button mat-fab [color]="btn.color" [matTooltip]="btn.tooltip" [disabled]="btn.disabled" (click)="actionBtn(btn.key)">
                <mat-icon>
                    {{ btn.icono }}
                </mat-icon>
            </button>
        </div>

        <div *ngIf="btn.tipo === 'mini-fab'">
            <button mat-mini-fab [color]="btn.color" [matTooltip]="btn.tooltip" [disabled]="btn.disabled" (click)="actionBtn(btn.key)">
                <mat-icon>
                    {{ btn.icono }}
                </mat-icon>
            </button>
        </div>

    </div>
</div>